export default function canPlaceItem(
  gridWidth: number,
  gridHeight: number,
  occupied: boolean[][],
  itemSize: { width: number; height: number },
  itemPosition: { x: number; y: number },
  originalPosition?: { x: number; y: number } | null,
): boolean {
  try {
    const { x, y } = itemPosition;
    const { width, height } = itemSize;

    // Проверка выхода за границы сетки
    if (x < 0 || y < 0 || x + width > gridWidth || y + height > gridHeight) {
      return false;
    }

    for (let j = y; j < y + height; j++) {
      for (let i = x; i < x + width; i++) {
        if (occupied[j]?.[i]) {
          // Если есть originalPosition, проверим: входит ли (i,j) в старую зону предмета
          // Проверяем без учета ячеек, который занимает сам предмет
          const inOriginal =
            originalPosition &&
            i >= originalPosition.x &&
            i < originalPosition.x + width &&
            j >= originalPosition.y &&
            j < originalPosition.y + height;

          if (!inOriginal) {
            return false;
          }
        }
      }
    }

    return true;
  } catch (e) {
    console.log({ e, gridWidth, gridHeight, occupied, itemSize, itemPosition, originalPosition });
    return false;
  }
}
